<app-response-banner
  [invisible]="!fail"
  [errorMessage]="'join.error_message' | translate"
  [success]="false"
>
</app-response-banner>
